/**
 * Little helper to inject Google Analytics and send events
 * @module lib/analytics
 */

/**
 * Generates an analytics snippets for the given GA key
 * @param {String} key - The Google Analytics key
 */
function analyticsSnippet(key) {
  return `
  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

  ga('create', '${key}', 'auto');`;
}

/**
 * Injects the analytics snippet if a GA_KEY variable is set on `window`
 * and the user hasn't enabled Do Not Track in their browser
 */
export function injectAnalyticsScript() {
  if (window.GA_KEY && !isDoNotTrackEnabled()) {
    // Need to create an HTMLScriptElement, not just append an HTML with `<script>` tags inside
    // as these won't get run
    // https://stackoverflow.com/questions/2592092/executing-script-elements-inserted-with-innerhtml
    const script = document.createElement('script');
    script.innerHTML = analyticsSnippet(window.GA_KEY);
    document.body.appendChild(script);
  }
}

/**
 * Checks if Do Not Track is enabled in the browser
 */
// https://medium.com/farewill/how-to-detect-and-use-do-not-track-on-your-website-77f21f62be48
export function isDoNotTrackEnabled() {
  const doNotTrackOption =
    window.doNotTrack ||
    window.navigator.doNotTrack ||
    window.navigator.msDoNotTrack;

  if (!doNotTrackOption) {
    return false;
  }

  if (doNotTrackOption.charAt(0) === '1' || doNotTrackOption === 'yes') {
    return true;
  }

  return false;
}

/**
 * Thin wrapper to send analytics, passing all arguments to the `ga` function
 * after `send`
 */
export function sendAnalytics() {
  runCommand('send', ...arguments);
}

/**
 * Thin wrapper to set a value for GA
 */
export function set() {
  runCommand('set', ...arguments);
  if (window.ga && !isDoNotTrackEnabled()) {
    window.ga.apply(null, ['set', ...arguments]);
  }
}

/**
 * Thin wrapper over the ga() function to ensure:
 *
 * 1. That is doesn't error if window.ga is not there
 * 2. That it respects the DNT settings (in case it's used on a page
 *    where GA it not loaded by the current script).
 *
 * All arguments are passed as is to the GA function
 */
function runCommand() {
  if (window.ga && !isDoNotTrackEnabled()) {
    window.ga(...arguments);
  }
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/analytics.js